import { render } from "./ModalChoixTypeDocuments.vue?vue&type=template&id=06917d2c&scoped=true&ts=true"
import script from "./ModalChoixTypeDocuments.vue?vue&type=script&lang=ts"
export * from "./ModalChoixTypeDocuments.vue?vue&type=script&lang=ts"

import "./ModalChoixTypeDocuments.vue?vue&type=style&index=0&id=06917d2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06917d2c"]])

export default __exports__